export default __webpack_public_path__ + "static/media/email-14-512-round.3755b3a4.png";